<template>
    <div class="pt-4 mt-3 d-flex flex-column scrollable">
        <div class="d-flex flex-column gap-3 text-center mb-4">
            <h3 class="fw-semi-bold m-0">Let's Begin</h3>
            <p class="text-secondary m-0">Before you can XXX, Please read and accept our Terms and Conditions</p>
        </div>

        <div class="d-flex flex-column gap-5">
            <ul class="d-flex flex-column gap-4 ps-4">
                <li><strong>Checkup isn't a diagnosis.</strong> It is only for your information and not a qualified
                    medical opinion</li>
                <li><strong>Checkup isn't for emergencies.</strong> Call your local emergency number right away when
                    there's a health emergency</li>
            </ul>
        </div>

        <div class="mt-auto form-check mb-3">
            <input class="form-check-input cursor-pointer" type="checkbox" v-model="selectedOptions" value="terms" id="termsCheck">
            <label class="form-check-label mt-n1 ms-2">
                I consent to my survey data being collected, used, and publicly displayed as explained in the
                <a href='/legal/v2/privacy_policy' target="_blank">privacy policy</a>,
                and I understand that I may withdraw my consent at any time
            </label>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const headings = ['User Agreement', 'Privacy', 'Proprietary Rights']
const emit = defineEmits(['page-viewed']);
const selectedOptions = ref([]);

watch(selectedOptions, (newVal, oldVal) => {
    emit('page-viewed', newVal.length > 0);
})
</script>


<style scoped lang="scss">
.scrollable {
    height: calc(100dvh - 200px);
    max-height: calc(100dvh - 200px);
    overflow-y: scroll;
    scrollbar-width: none;
}

@media (max-width: 991px) {
    .scrollable {
        height: calc(100dvh - 176px);
        max-height: calc(100dvh - 176px);
        overflow-y: scroll;
        scrollbar-width: none;
    }
}

@media (max-width: 767px) {
    .scrollable {
        height: calc(100dvh - 160px);
        max-height: calc(100dvh - 160px);
        overflow-y: scroll;
        scrollbar-width: none;
    }
}

.form-check {
    padding-left: 2rem !important;
}
</style>
